'use strict';

function AlbumPhotosDetailsController($rootScope, $scope, objectMakerFactory, dataHolderFactory, dataRequestService, usSpinnerService, onControllerLabelsForLanguageFactory) {
  var self = this;

  this.getAlbumPhotosDetails = function () {
    $scope.albumPhotosDetailsControl.mapAlbumPhotos = dataHolderFactory.getMapAlbumPhotos();
    $scope.albumPhotosDetailsControl.photos = $scope.albumPhotosDetailsControl.mapAlbumPhotos[dataHolderFactory.getAlbumPhotoId()];
    $scope.albumPhotosDetailsControl.titlePhotos = onControllerLabelsForLanguageFactory.getLabel('TITLEALBUMPHOTOSDETAIL') + dataHolderFactory.getAlbumPhotoId();
  };

  $scope.initAlbumPhotosDetailsController = function () {
    $scope.albumPhotosDetailsControl = objectMakerFactory.viewObjectControlForAlbumPhotosDetail();
    self.getAlbumPhotosDetails();
  };

  $scope.restoreViewControl = function () {
    $rootScope.appControl.showAlbumBoxDetails = false;
  };
}

AlbumPhotosDetailsController.$inject = ['$rootScope', '$scope', 'objectMakerFactory', 'dataHolderFactory', 'dataRequestService', 'usSpinnerService', 'onControllerLabelsForLanguageFactory']
export default AlbumPhotosDetailsController



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/albumPhotosDetailsController.js